
export const getDiffDays = ((fromDate,toDate) => {
    const date1 = fromDate;
    const date2 = new Date(toDate);
    const diffTime = Math.round(date2 - date1);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
});


export const getExpirationLabel=((expDays)=>{

    if (expDays!=null){
        if (expDays>60){
            return "VALID";
        }else if (expDays>30){
            return "EXPIRING SOON";
        }else{
            return "EXPIRED";
        }
    }else{
        return "";
    }

});

export const extractHostnamePort = ((url) => {
    const matches = /([a-zA-Z]{4,5}):\/\/([\-\w\.]{1,253})(?:\:(\d{0,5}))?/.exec(url);
    return {
        "protocol": matches[1],
        "hostname": matches[2],
        "port": matches[3] == undefined ? 443 : matches[3]
    }
});

export const getDirectionLabel=((direction)=>{
    switch (direction){
        case "I":
            return "INBOUND";
        case "O":
            return "OUTBOUND";
        default:
            return direction;
    }
});